import React, { FC } from 'react';
import { FormField, FormFieldProps } from '../FormField';
import { DatePicker } from '../DatePicker';

export type FormDatePickerProps = FormFieldProps;

export const FormDatePicker: FC<FormDatePickerProps> = ({ ...props }) => {
	return <FormField control={DatePicker} {...props} />;
};
